import { render, staticRenderFns } from "./usuarios-clientedatos.vue?vue&type=template&id=39eea76e&"
import script from "./usuarios-clientedatos.vue?vue&type=script&lang=js&"
export * from "./usuarios-clientedatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports